import * as React from 'react';

export function NativeSection() {
  return (
    <section className="whyus-native">
      <style>{`
        .whyus-native {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .whyus-native-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .whyus-native h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 24px;
          line-height: 1.3;
        }
        .whyus-native p {
          font-size: 17px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .whyus-native p:last-child {
          margin-bottom: 0;
        }
        .whyus-native .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        @media (max-width: 640px) {
          .whyus-native h2 {
            font-size: 24px;
          }
          .whyus-native p {
            font-size: 16px;
          }
        }
      `}</style>
      <div className="whyus-native-inner">
        <h2>Nuestro negocio ES la web.</h2>
        <p>
          No es un canal extra. No es "para cuando tengamos tiempo". No es un PDF con precios.
        </p>
        <p>
          <span className="highlight">Cada peso que invertimos va a que tu experiencia de compra sea mejor. Cada día.</span>
        </p>
        <p>
          Mientras otros atienden el mostrador y actualizan la web "cuando pueden", nosotros diseñamos, testeamos y mejoramos la plataforma constantemente.
        </p>
      </div>
    </section>
  );
}
